// src/components/EntriesList/FeiertageDialog.js
import React, { useState } from 'react';
import { styles } from './styles/entryStyles';

const bundeslaender = [
  { value: 'BW', label: 'Baden-Württemberg' },
  { value: 'BY', label: 'Bayern' },
  { value: 'BE', label: 'Berlin' },
  { value: 'BB', label: 'Brandenburg' },
  { value: 'HB', label: 'Bremen' },
  { value: 'HH', label: 'Hamburg' },
  { value: 'HE', label: 'Hessen' },
  { value: 'MV', label: 'Mecklenburg-Vorpommern' },
  { value: 'NI', label: 'Niedersachsen' },
  { value: 'NW', label: 'Nordrhein-Westfalen' },
  { value: 'RP', label: 'Rheinland-Pfalz' },
  { value: 'SL', label: 'Saarland' },
  { value: 'SN', label: 'Sachsen' },
  { value: 'ST', label: 'Sachsen-Anhalt' },
  { value: 'SH', label: 'Schleswig-Holstein' },
  { value: 'TH', label: 'Thüringen' },
];

/**
 * Dialog zur Auswahl eines Bundeslandes für die Feiertage
 */
function FeiertageDialog({ onCancel, onSave, aktuellesJahr }) {
  const [selectedBundesland, setSelectedBundesland] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    if (!selectedBundesland) {
      alert('Bitte ein Bundesland auswählen!');
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`https://feiertage-api.de/api/?jahr=${aktuellesJahr}&nur_land=${selectedBundesland}`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error('Fehler beim Abrufen der Feiertage');
      }
      
      const formattedData = Object.entries(data).map(([name, details]) => ({
        name,
        date: details.datum,
      }));
      
      onSave(formattedData);
    } catch (err) {
      alert(`Fehler: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.popupOverlay}>
      <div style={styles.popupContent}>
        <h2>Wähle ein Bundesland für {aktuellesJahr}</h2>
        <select
          value={selectedBundesland}
          onChange={(e) => setSelectedBundesland(e.target.value)}
          style={styles.popupSelect}
          disabled={isLoading}
        >
          <option value="">-- Bitte auswählen --</option>
          {bundeslaender.map((land) => (
            <option key={land.value} value={land.value}>
              {land.label}
            </option>
          ))}
        </select>
        <div style={styles.popupButtons}>
          <button 
            onClick={handleSave} 
            style={styles.popupOkButton}
            disabled={isLoading}
          >
            {isLoading ? 'Lade...' : 'OK'}
          </button>
          <button 
            onClick={onCancel} 
            style={styles.popupCancelButton}
            disabled={isLoading}
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
}

export default FeiertageDialog;